"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calculateUnreadThreadsCountsFromChannels = exports.calculateUnreadMessagesCountsFromChannels = exports.calculateUnreadMentionsCountsFromChannels = exports.CHAT_STATE_ACTIONS = exports.CHAT_LOADING_STATES = void 0;
exports.composeFakeChannelId = composeFakeChannelId;
exports.composeHiddenNameMsg = composeHiddenNameMsg;
exports.composeThreadMessagesProps = composeThreadMessagesProps;
exports.composeUserNickName = composeUserNickName;
exports.countMessageAsUnread = exports.countChannelUnreadThreads = exports.countChannelUnreadMentions = exports.countChannelUnread = void 0;
exports.countUnread = countUnread;
exports.getChatFormatDate = getChatFormatDate;
exports.getChatMember = getChatMember;
exports.getChatPreviewerMember = getChatPreviewerMember;
exports.getLastRead = getLastRead;
exports.getLatestMessage = getLatestMessage;
exports.isChannelMember = void 0;
exports.isFakeChannelId = isFakeChannelId;
exports.isUserChatsAdmin = exports.isUserChatModerator = exports.isUnreadMessage = exports.isUnreadMentionMessage = exports.isMyMessageWithUnreadReply = exports.isMessageForAllFromAdminOrModerator = void 0;
exports.isUserInChat = isUserInChat;
exports.useMutableCallbackWrapper = exports.updateChatToMoveOnTop = void 0;
var _lodash = require("lodash");
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _react = require("react");
var _messageTypes = require("./messageTypes");
var _ = require("./..");
var _constants = require("../constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function getChatFormatDate(date) {
  if (!date) {
    return;
  }
  // Until we completely re-factor chat, have no choice but to use guess()
  // here to show same values inside open dialogs and on preview
  var tzName = _momentTimezone.default.tz.guess();
  var myMoment = (0, _momentTimezone.default)(date).tz(tzName);
  return myMoment.calendar(null, {
    sameDay: 'hh:mm A',
    lastDay: '[yesterday]',
    lastWeek: 'MM/DD',
    sameElse: function sameElse(now) {
      return myMoment.year() === now.year() ? 'MM/DD' : 'MM/DD/YYYY';
    }
  });
}
function getChatMember(_ref) {
  var owner = _ref.owner,
    members = _ref.members,
    previewUserId = _ref.previewUserId;
  if (!owner || (0, _lodash.isEmpty)(members)) {
    return;
  }
  var searchId = previewUserId || owner.accountId;
  return (0, _lodash.find)(members, function (m) {
    return m.user.id !== searchId;
  });
}
function isUserInChat(_ref2) {
  var members = _ref2.members,
    owner = _ref2.owner;
  if ((0, _lodash.isEmpty)(members)) {
    return false;
  }
  return !!members[owner.accountId];
}
function getChatPreviewerMember(_ref3) {
  var members = _ref3.members,
    owner = _ref3.owner,
    isInChat = _ref3.isInChat,
    previewerCheck = _ref3.previewerCheck;
  if (!previewerCheck || (0, _lodash.isEmpty)(members)) {
    return;
  }
  if (isInChat) {
    return owner;
  }
  return (0, _lodash.find)(members, function (m) {
    return [_.UserRoles.SuperAdmin, _.UserRoles.Admin].indexOf(m.applicationRole) === -1;
  });
}
function getLastRead(_ref4) {
  var _channel$state, _read$userId;
  var channel = _ref4.channel,
    userId = _ref4.userId;
  var read = channel === null || channel === void 0 ? void 0 : (_channel$state = channel.state) === null || _channel$state === void 0 ? void 0 : _channel$state.read;
  return read && read[userId] ? (_read$userId = read[userId]) === null || _read$userId === void 0 ? void 0 : _read$userId.last_read : null;
}
function countUnread(_ref5) {
  var userId = _ref5.userId,
    messages = _ref5.messages,
    lastRead = _ref5.lastRead;
  return (messages || []).filter(function (m) {
    var ownsMsg = m.user.id === userId;
    var isMsgUnread = !lastRead || m.created_at > lastRead;
    return !ownsMsg && isMsgUnread && m.type !== _messageTypes.messageTypes.SYSTEM;
  }).length;
}
var maxRowLength = 36;
function getLatestMessage(_ref6) {
  var channel = _ref6.channel,
    _ref6$textLimit = _ref6.textLimit,
    textLimit = _ref6$textLimit === void 0 ? maxRowLength * 3 : _ref6$textLimit;
  var messages = (channel === null || channel === void 0 ? void 0 : channel.state.messages) || [];
  var latestMessage = messages[messages.length - 1];
  if (!latestMessage) {
    return 'Nothing yet...';
  }
  if (latestMessage.deleted_at) {
    return 'Message deleted';
  }
  if (latestMessage.text) {
    var preview = latestMessage.text.slice(0, textLimit);
    return preview.length < latestMessage.text.length ? "".concat(preview, "...") : preview;
  } else {
    if (latestMessage.command) {
      return '/' + latestMessage.command;
    }
    if (latestMessage.attachments.length) {
      return '🏙 Attachment...';
    }
    return 'Empty message...';
  }
}
function composeUserNickName(user) {
  return _objectSpread(_objectSpread({}, user), {}, {
    name: user === null || user === void 0 ? void 0 : user.nickName
  });
}
function composeHiddenNameMsg(msg) {
  var reactions = ((msg === null || msg === void 0 ? void 0 : msg.latest_reactions) || []).map(function (r) {
    return _objectSpread(_objectSpread({}, r), {}, {
      user: composeUserNickName(r === null || r === void 0 ? void 0 : r.user)
    });
  });
  return _objectSpread(_objectSpread({}, msg), {}, {
    user: composeUserNickName(msg === null || msg === void 0 ? void 0 : msg.user),
    latest_reactions: reactions
  });
}
function composeThreadMessagesProps(_ref7) {
  var threadMessages = _ref7.threadMessages,
    thread = _ref7.thread;
  var noReply = typeof thread === 'boolean' || !thread;
  return {
    threadMessages: threadMessages.map(function (m) {
      return composeHiddenNameMsg(m);
    }),
    thread: noReply ? thread : composeHiddenNameMsg(thread)
  };
}

/**
 * According to stream-chat-react lib logic, there is no ability to inactivate all chats,
 * i.e. if you pass existing channel id (customActiveChannel prop to ChannelList component),
 * it'll be activated, but if passed channel id doesn't exist, nothing will be done,
 * if no customActiveChannel is passed, the first of the chat is activated,
 * so fake id is created and passed in order to inactivate channels
 * for first channels list appearance (according to app requirements).
 */

var fakeIdPrefix = 'fake_';
function composeFakeChannelId() {
  return "".concat(fakeIdPrefix).concat(+new Date());
}
function isFakeChannelId(channelId) {
  return new RegExp("^".concat(fakeIdPrefix)).test(channelId);
}
var CHAT_LOADING_STATES = {
  FETCHING_CREDENTIALS: 1,
  CLIENT_INITIALIZATION: 2
};
exports.CHAT_LOADING_STATES = CHAT_LOADING_STATES;
var CHAT_STATE_ACTIONS = {
  CREDENTIALS_LOADING_ATTEMPT: 1,
  CLIENT_INITIALIZATION_ATTEMPT: 2,
  CHANNELS_INITIALIZATION_ATTEMPT: 3,
  CREDENTIALS_LOADING_FAILED: 11,
  CLIENT_INITIALIZATION_FAILED: 12,
  CHANNELS_INITIALIZATION_FAILED: 13,
  CREDENTIALS_LOADING_DONE: 21,
  CLIENT_INITIALIZATION_DONE: 22,
  CHANNELS_INITIALIZATION_DONE: 23
};
exports.CHAT_STATE_ACTIONS = CHAT_STATE_ACTIONS;
var useMutableCallbackWrapper = function useMutableCallbackWrapper(callback) {
  var wrapper = (0, _react.useRef)(_lodash.noop);
  (0, _react.useEffect)(function () {
    wrapper.current = callback;
  }, [callback]);
  return wrapper;
};
exports.useMutableCallbackWrapper = useMutableCallbackWrapper;
var isChannelMember = function isChannelMember(channel) {
  return !(0, _lodash.isEmpty)(channel === null || channel === void 0 ? void 0 : channel.state.membership);
};
exports.isChannelMember = isChannelMember;
var countMessageAsUnread = function countMessageAsUnread(message, client, channel) {
  var _message$user, _message$user2;
  if (message.shadowed || message.silent || message.type === 'deleted' || !isChannelMember(channel) || ((_message$user = message.user) === null || _message$user === void 0 ? void 0 : _message$user.id) === client.userID || message.type === _messageTypes.messageTypes.SYSTEM || (_message$user2 = message.user) !== null && _message$user2 !== void 0 && _message$user2.id && client.userMuteStatus(message.user.id) || channel.muteStatus().muted) {
    return false;
  }
  return true;
};
exports.countMessageAsUnread = countMessageAsUnread;
var isUserChatsAdmin = function isUserChatsAdmin(user) {
  return user.role === _constants.CHAT_ADMIN_ROLE_NAME;
};
exports.isUserChatsAdmin = isUserChatsAdmin;
var isUserChatModerator = function isUserChatModerator(member) {
  return member === null || member === void 0 ? void 0 : member.is_moderator;
};
exports.isUserChatModerator = isUserChatModerator;
var isMessageForAllFromAdminOrModerator = function isMessageForAllFromAdminOrModerator(message, member) {
  return (isUserChatsAdmin(message.user) || isUserChatModerator(member)) && message.text.includes("".concat(_constants.MENTION_SIGN).concat(_constants.FAKE_HERE_USER_NAME));
};
exports.isMessageForAllFromAdminOrModerator = isMessageForAllFromAdminOrModerator;
var messageContainsMention = function messageContainsMention(message, userID, member) {
  var _message$mentioned_us;
  return ((_message$mentioned_us = message.mentioned_users) === null || _message$mentioned_us === void 0 ? void 0 : _message$mentioned_us.some(function (user) {
    return user.id === userID;
  })) || message.user.id !== userID && isMessageForAllFromAdminOrModerator(message, member);
};

// myUnreadMessage means that there are some unread relpies
var myUnreadMessage = function myUnreadMessage(message, userID, lastRead) {
  var isUpdateUnread = !lastRead || message.updated_at > lastRead;
  var isMy = message.user.id === userID;
  return isMy && isUpdateUnread && message.reply_count > 0;
};
var isMyMessageWithUnreadReply = function isMyMessageWithUnreadReply(message, client, channel) {
  var userID = client.userID;
  var lastRead = channel.lastRead();
  return countMessageAsUnread(message, client, channel) && myUnreadMessage(message, userID, lastRead);
};
exports.isMyMessageWithUnreadReply = isMyMessageWithUnreadReply;
var isUnreadMessage = function isUnreadMessage(message, client, channel) {
  var lastRead = channel.lastRead();
  var isUnread = !lastRead || message.created_at > lastRead;
  return countMessageAsUnread(message, client, channel) && isUnread;
};

// besides messages with real mentions we also include unread messages from the threads of user's messages
exports.isUnreadMessage = isUnreadMessage;
var isUnreadMentionMessage = function isUnreadMentionMessage(message, client, channel) {
  var userId = client.userID;
  var lastRead = channel.lastRead();
  var isUnread = !lastRead || message.created_at > lastRead;
  return countMessageAsUnread(message, client, channel) && isUnread && messageContainsMention(message, userId, channel.state.members[message.user.id]);
};
exports.isUnreadMentionMessage = isUnreadMentionMessage;
var countChannelUnread = function countChannelUnread(client, channel) {
  var count = 0;
  for (var i = 0; i < channel.state.messages.length; i += 1) {
    var message = channel.state.messages[i];
    if (isUnreadMessage(message, client, channel)) {
      count++;
    }
  }
  return count;
};
exports.countChannelUnread = countChannelUnread;
var countChannelUnreadMentions = function countChannelUnreadMentions(client, channel) {
  var count = 0;
  for (var i = 0; i < channel.state.messages.length; i += 1) {
    var message = channel.state.messages[i];
    if (isUnreadMentionMessage(message, client, channel)) {
      count++;
    }
  }
  return count;
};
exports.countChannelUnreadMentions = countChannelUnreadMentions;
var countChannelUnreadThreads = function countChannelUnreadThreads(client, channel) {
  var count = 0;
  for (var i = 0; i < channel.state.messages.length; i += 1) {
    var message = channel.state.messages[i];
    if (isMyMessageWithUnreadReply(message, client, channel)) {
      count++;
    }
  }
  return count;
};
exports.countChannelUnreadThreads = countChannelUnreadThreads;
var calculateUnreadMessagesCountsFromChannels = function calculateUnreadMessagesCountsFromChannels(client, channels, totalUnreadCount) {
  if (totalUnreadCount === 0) {
    return {
      total: 0,
      oneToOneChannels: 0,
      groupChannels: 0,
      communityChannels: 0
    };
  }
  var _ref8 = channels || {},
    oneToOneChannels = _ref8.oneToOne,
    communityChannels = _ref8.community,
    groupChannels = _ref8.group;
  var oneToOneUnreadCount = (0, _lodash.sum)((0, _lodash.map)(oneToOneChannels, function (channel) {
    return isChannelMember(channel) ? countChannelUnread(client, channel) || 0 : 0;
  })) || 0;
  var communityUnreadCount = (0, _lodash.sum)((0, _lodash.map)(communityChannels, function (channel) {
    return isChannelMember(channel) ? countChannelUnread(client, channel) || 0 : 0;
  }));
  var groupUnreadCount = (0, _lodash.sum)((0, _lodash.map)(groupChannels, function (channel) {
    return isChannelMember(channel) ? countChannelUnread(client, channel) || 0 : 0;
  }));
  return {
    total: oneToOneUnreadCount + communityUnreadCount + groupUnreadCount,
    oneToOneChannels: oneToOneUnreadCount,
    groupChannels: groupUnreadCount,
    communityChannels: communityUnreadCount
  };
};
exports.calculateUnreadMessagesCountsFromChannels = calculateUnreadMessagesCountsFromChannels;
var calculateUnreadMentionsCountsFromChannels = function calculateUnreadMentionsCountsFromChannels(client, channels, totalUnreadCount) {
  if (totalUnreadCount === 0) {
    return {
      total: 0,
      oneToOneChannels: 0,
      groupChannels: 0,
      communityChannels: 0
    };
  }
  var _ref9 = channels || {},
    communityChannels = _ref9.community,
    groupChannels = _ref9.group;
  var communityUnreadCount = (0, _lodash.sum)((0, _lodash.map)(communityChannels, function (channel) {
    return countChannelUnreadMentions(client, channel) || 0;
  }) || 0);
  var groupUnreadCount = (0, _lodash.sum)((0, _lodash.map)(groupChannels, function (channel) {
    return countChannelUnreadMentions(client, channel) || 0;
  }) || 0);
  return {
    total: groupUnreadCount + communityUnreadCount,
    groupChannels: groupUnreadCount,
    communityChannels: communityUnreadCount
  };
};
exports.calculateUnreadMentionsCountsFromChannels = calculateUnreadMentionsCountsFromChannels;
var calculateUnreadThreadsCountsFromChannels = function calculateUnreadThreadsCountsFromChannels(client, channels) {
  var _ref10 = channels || {},
    communityChannels = _ref10.community,
    groupChannels = _ref10.group;
  var communityUnreadCount = (0, _lodash.sum)((0, _lodash.map)(communityChannels, function (channel) {
    return countChannelUnreadThreads(client, channel) || 0;
  }) || 0);
  var groupUnreadCount = (0, _lodash.sum)((0, _lodash.map)(groupChannels, function (channel) {
    return countChannelUnreadThreads(client, channel) || 0;
  }) || 0);
  return {
    total: groupUnreadCount + communityUnreadCount,
    groupChannels: groupUnreadCount,
    communityChannels: communityUnreadCount
  };
};

// need to call backend to update target chat with any data
// to move it on top of the loaded channels
// this is applied for the case when you need to navigate to particular chat
// after calling backend you need to pass `?${SORT_CHANNEL_BY_QUERY_NAME}=updatedAt to
// chat pathname for channels to be sorted by updated_at
exports.calculateUnreadThreadsCountsFromChannels = calculateUnreadThreadsCountsFromChannels;
var updateChatToMoveOnTop = function updateChatToMoveOnTop(params) {
  return _.api.patch((0, _.getUpdatePatientChatUrl)(), params);
};
exports.updateChatToMoveOnTop = updateChatToMoveOnTop;